import { combineReducers } from "redux";
import * as authority from "./authority";
import * as cognitoToken from "./cognitoToken";
import * as header from "./header";
import * as login from "./login";
import * as sidemenu from "./sidemenu";

export const rootReducer = combineReducers({ ...login, ...authority, ...cognitoToken, ...sidemenu, ...header, });
